const IntroSection = () => {
    return (
        <div className="space-y-6">
            <h1 className="text-3xl font-bold text-slate-900">
                📚 Hướng Dẫn Sử Dụng Hệ Thống EduSmart LMS
            </h1>
            <p className="text-lg text-slate-700">
                Chào mừng bạn đến với EduSmart Learning Management System! Tài liệu này sẽ hướng dẫn bạn cách sử dụng
                các tính năng của hệ thống một cách hiệu quả.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
                <div className="bg-indigo-50 p-6 rounded-lg border border-indigo-200">
                    <h3 className="text-lg font-semibold text-indigo-900 mb-2">🎯 Mục đích</h3>
                    <p className="text-slate-700">
                        Hệ thống LMS giúp bạn học tập trực tuyến với các công cụ hiện đại,
                        bao gồm trợ lý AI thông minh, quản lý học phí và theo dõi tiến trình học tập.
                    </p>
                </div>
                <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                    <h3 className="text-lg font-semibold text-green-900 mb-2">✨ Tính năng nổi bật</h3>
                    <ul className="text-slate-700 space-y-1">
                        <li>• Trợ lý AI thông minh (GPT-4)</li>
                        <li>• Thanh toán học phí QR Code</li>
                        <li>• Bài kiểm tra trực tuyến</li>
                        <li>• Quản lý lịch học</li>
                        <li>• Bài học lý thuyết</li>
                        <li>• Tải tài liệu PDF</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default IntroSection;
